<template>
  <div class="PayJurisdiction">
    <div
      :class="widthNum ? 'table-container2' : 'table-container'"
      :style="{ minWidth: tableMinWidth + 'px' }"
    >
      <!-- 表头行 -->
      <div class="table-row">
        <div :class="widthNum ? 'header-cell2' : 'header-cell'">
          {{ tableData.title }}
        </div>
        <div
          v-for="(item, index) in tableData.body"
          :key="index"
          :class="[
            getHeaderBgClass(item.web_bg_type),
            widthNum ? 'header-cell2' : 'header-cell',
          ]"
        >
          {{ item.title }}
        </div>
      </div>

      <!-- 数据行 -->
      <div
        v-for="(headerItem, headerIndex) in tableData.header"
        :key="headerIndex"
        class="table-row"
        :class="getRowBgClass(headerItem.status)"
      >
        <div
          :class="[
            getHeaderCellClass(headerItem.tag),
            widthNum ? 'data-cell2' : 'data-cell',
          ]"
        >
          {{ headerItem.title }}
        </div>
        <div
          v-for="(bodyItem, bodyIndex) in tableData.body"
          :key="bodyIndex"
          :class="[
            getDataCellBgClass(bodyItem.web_bg_type),
            widthNum ? 'data-cell2' : 'data-cell',
          ]"
        >
          <template
            v-if="getCellValue(bodyItem.list, headerItem.tag).type == 1"
          >
            {{ getCellValue(bodyItem.list, headerItem.tag).title }}
          </template>
          <template
            v-else-if="getCellValue(bodyItem.list, headerItem.tag).type == 2"
          >
            <img
              class="checkmark"
              :class="
                getDataCellBgClass(bodyItem.web_bg_type) == 'bg-highlight'
                  ? 'checkmark2'
                  : ''
              "
              width="20"
              :src="$utils.getPng('select-active')"
              alt=""
            />
          </template>
          <template
            v-else-if="getCellValue(bodyItem.list, headerItem.tag).type == 3"
          >
            <div
              class="checkmark shux"
              :class="
                getDataCellBgClass(bodyItem.web_bg_type) == 'bg-highlight'
                  ? 'checkmark2'
                  : ''
              "
            ></div>
          </template>
          <template v-else>
            {{ getCellValue(bodyItem.list, headerItem.tag).title }}
          </template>
        </div>
      </div>
    </div>
    <span
      class="v-desc"
      :class="widthNum ? 'v-desc' : 'v-desc2'"
      style="text-align: left"
      :style="{ marginTop: PayJurisUrl == 0 ? '12px' : '' }"
      >{{ $t("vip.vipIntr") }}</span
    >
  </div>
</template>

<script>
import { getPrivilegeCompare } from "@/utils/apiList/vip.js";
export default {
  props: {
    widthNum: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: {},
    };
  },
  computed: {
    // 获取第一列宽度
    firstColumnWidth() {
      return this.widthNum ? 136 : 145;
    },
    // 获取其他列宽度
    otherColumnWidth() {
      return this.widthNum ? 156 : 211;
    },
    tableMinWidth() {
      if (!this.tableData.body || !this.tableData?.body?.length) {
        return this.firstColumnWidth; // 默认第一列宽度
      }
      // 第一列145px + 其他列每列211px
      return (
        this.firstColumnWidth +
        this.tableData?.body?.length * this.otherColumnWidth
      );
    },
  },
  created() {
    this.getPrivilegeCompareFn();
  },
  methods: {
    getPrivilegeCompareFn() {
      getPrivilegeCompare().then((res) => {
        if (res.status == 1) {
          this.tableData = res.data;
        }
      });
    },
    getHeaderCellClass(tag) {
      if (tag == "10000") {
        return "category-header";
      }
      return "sub-header";
    },
    getCellValue(list, tag) {
      // 如果是分类标题(tag为10000)，返回空
      if (tag == "10000") {
        return { title: "", type: "1" };
      }
      const item = list.find((item) => item.tag == tag);
      return item || { title: "", type: "1" };
    },
    getHeaderBgClass(webBgType) {
      return webBgType == "1" ? "bg-highlight" : "bg-normal";
    },
    getDataCellBgClass(webBgType) {
      return webBgType == "1" ? "bg-highlight" : "bg-normal";
    },
    getRowBgClass(status) {
      return status == "1" ? "row-bg-gray" : "row-bg-white";
    },
  },
};
</script>

<style lang="scss" scoped>
.PayJurisdiction {
  width: 100%;
  overflow-x: auto;

  .v-desc {
    line-height: 22px;
    margin-top: 20px;
    display: flex;
    @include useTheme {
      color: getVar("text-color1-bdbdbe");
    }
  }

  .v-desc2 {
    line-height: 22px;
    margin-top: 32px;
    display: flex;
    @include useTheme {
      color: getVar("text-color1-bdbdbe");
    }
  }

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    height: 8px !important;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;

    &:hover {
      background: #a8a8a8 !important;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    width: 75%;
    min-width: 145px; // 第一列宽度
    position: relative; // 为绝对定位的子元素提供参考
    margin-top: 12px;
    margin-bottom: 12px;
    border-radius: 20px;
    // overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      @include useTheme {
        border: getVar("border-color2-f6f6f6");
      }
      border-radius: 20px;
      pointer-events: none;
      z-index: 1;
    }
  }

  .table-container2 {
    display: flex;
    flex-direction: column;
    width: 75%;
    min-width: 136px; // 第一列宽度
    position: relative; // 为绝对定位的子元素提供参考
    margin-top: 12px;
    margin-bottom: 12px;
    border-radius: 20px;
    // overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      @include useTheme {
        border: getVar("border-color2-f6f6f6");
      }
      border-radius: 20px;
      pointer-events: none;
      z-index: 1;
    }
  }

  .table-row {
    display: flex;
    width: 100%;
  }

  .header-cell {
    display: flex;
    align-items: center;
    height: 80px;
    flex-shrink: 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    // text-align: center;
    // border: 1px solid #e5e5e5;

    @include useTheme {
      background: getVar("vip-color1-f9f9f9");
    }

    // 第一个单元格（会员权益）
    &:first-child {
      width: 145px;
      padding-left: 32px;
      padding-right: 12px;
      border-top-left-radius: 20px !important;
    }

    &:last-child {
      border-top-right-radius: 20px !important;
    }

    // 其他标题单元格
    &:not(:first-child) {
      width: 211px;
      justify-content: center;
    }
  }

  // web_bg_type为1的标题（长期会员Ultra）- 单独设置
  .header-cell.bg-highlight {
    // height: 92px !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
    position: relative !important;
    z-index: 20 !important;
    top: -12px !important; // 使用top而不是margin-top
    padding-top: 12px;
    position: relative;
    color: #f67942;
    @include useTheme {
      background: getVar("vip-bgcolor-fff5ed") !important;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 100%;
      height: 12px;
      @include useTheme {
        background: getVar("vip-bgcolor-fff5ed") !important;
      }
    }
  }

  .header-cell2 {
    display: flex;
    align-items: center;
    height: 80px;
    flex-shrink: 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    // text-align: center;
    // border: 1px solid #e5e5e5;

    @include useTheme {
      background: getVar("vip-color1-f9f9f9");
    }

    // 第一个单元格（会员权益）
    &:first-child {
      width: 136px;
      padding-left: 24px;
      padding-right: 12px;
      border-top-left-radius: 20px !important;
    }

    &:last-child {
      border-top-right-radius: 20px !important;
    }

    // 其他标题单元格
    &:not(:first-child) {
      width: 156px;
      justify-content: center;
    }
  }

  // web_bg_type为1的标题（长期会员Ultra）- 单独设置
  .header-cell2.bg-highlight {
    // height: 92px !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
    position: relative !important;
    z-index: 20 !important;
    top: -12px !important; // 使用top而不是margin-top
    padding-top: 12px;
    position: relative;
    color: #f67942;
    @include useTheme {
      background: getVar("vip-bgcolor-fff5ed") !important;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 100%;
      height: 12px;
      @include useTheme {
        background: getVar("vip-bgcolor-fff5ed") !important;
      }
    }
  }

  .data-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    // height: 52px; // 设置默认高度
    // border: 1px solid #e5e5e5;
    font-size: 12px;

    @include useTheme {
      color: getVar("text-color2-2c2c2c");
    }

    // 第一个单元格（会员权益列）
    &:first-child {
      width: 145px;
    }

    // 其他数据单元格
    &:not(:first-child) {
      width: 211px;
    }

    &.category-header {
      height: 40px !important;
      font-size: 12px;
      color: #bdbdbe;
      line-height: 20px;
      align-items: flex-end;
      justify-content: flex-start;
      padding-left: 32px;
      padding-right: 12px;
      @include useTheme {
        color: getVar("text-color1-bdbdbe");
      }
    }

    &.sub-header {
      height: 52px;
      align-items: center;
      justify-content: flex-start;
      padding-left: 32px;
      padding-right: 12px;
      font-weight: 400;
      // @include useTheme {
      //   background: getVar("vip-color2-FFFFFF");
      // }
    }
    &.bg-normal {
      font-weight: 500;
    }
    &.bg-highlight {
      font-weight: 500;
    }
  }

  .data-cell2 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    // height: 52px; // 设置默认高度
    // border: 1px solid #e5e5e5;
    font-size: 12px;

    @include useTheme {
      color: getVar("text-color2-2c2c2c");
    }

    // 第一个单元格（会员权益列）
    &:first-child {
      width: 136px;
    }

    // 其他数据单元格
    &:not(:first-child) {
      width: 156px;
    }

    &.category-header {
      height: 40px !important;
      font-size: 12px;
      color: #bdbdbe;
      line-height: 20px;
      align-items: flex-end;
      justify-content: flex-start;
      padding-left: 24px;
      padding-right: 12px;
      @include useTheme {
        color: getVar("text-color1-bdbdbe");
      }
    }

    &.sub-header {
      height: 52px;
      align-items: center;
      justify-content: flex-start;
      padding-left: 24px;
      padding-right: 12px;
      font-weight: 400;
      // @include useTheme {
      //   background: getVar("vip-color2-FFFFFF");
      // }
    }
    &.bg-normal {
      font-weight: 500;
    }
    &.bg-highlight {
      font-weight: 500;
    }
  }

  .bg-normal {
  }

  .bg-highlight {
    // background: #fff3e0 !important; // 橙色高亮，优先级最高
  }

  // 为最后一个bg-highlight数据单元格添加底部圆角
  .table-row:last-child .data-cell.bg-highlight {
    border-bottom-left-radius: 16px !important;
    border-bottom-right-radius: 16px !important;

    position: relative !important;
    z-index: 20 !important;
    top: 12px !important; // 使用top而不是margin-top
    position: relative;

    .checkmark2 {
      margin-top: -24px;
    }
    &::after {
      content: "";
      position: absolute;
      top: -12px;
      left: 0;
      width: 100%;
      height: 12px;
      @include useTheme {
        background: getVar("text-color1-fffbf8") !important;
      }
    }
  }

  .table-row:last-child .data-cell2.bg-highlight {
    border-bottom-left-radius: 16px !important;
    border-bottom-right-radius: 16px !important;

    position: relative !important;
    z-index: 20 !important;
    top: 12px !important; // 使用top而不是margin-top
    position: relative;
    .checkmark2 {
      margin-top: -24px;
    }
    &::after {
      content: "";
      position: absolute;
      top: -12px;
      left: 0;
      width: 100%;
      height: 12px;
      @include useTheme {
        background: getVar("text-color1-fffbf8") !important;
      }
    }
  }

  // 为表格底部角落添加圆角
  .table-row:last-child {
    border-bottom-left-radius: 20px !important;
  }

  .table-row:last-child {
    border-bottom-right-radius: 20px !important;
  }

  // 整行背景色
  .row-bg-gray {
    @include useTheme {
      background: getVar("vip-color1-f9f9f9");
    }

    // 为row-bg-gray行中的bg-highlight设置特定背景色
    .bg-highlight {
      color: #f67942 !important;
      @include useTheme {
        background: getVar("vip-bgcolor-fff5ed") !important;
      }
    }
  }

  .row-bg-white {
    @include useTheme {
      background: getVar("vip-color2-FFFFFF");
    }

    // 为row-bg-white行中的bg-highlight设置特定背景色
    .bg-highlight {
      color: #f67942 !important;
      @include useTheme {
        background: getVar("text-color1-fffbf8") !important;
      }
    }
  }

  .checkmark {
    opacity: 0.5;
  }
  .checkmark2 {
    opacity: 1;
  }
  .shux {
    width: 12px;
    height: 2px;
    background: #f67942;
  }
}
</style>
